export default __webpack_public_path__ + "static/ramsa-23e1244d6efe89979806ed1caf73da50.png";